import React, { Component } from "react";
import { Navbar, Nav, NavItem, MenuItem, Form, FormGroup, FormControl, Button, NavDropdown } from 'react-bootstrap'
import { Link } from "react-router-dom"
import { connect } from 'react-redux'
import NavbarCart from './navbar_cart'
import { fetchSearchInput, fetchProducts, changeSearchLabel, setLoadingSearchPage, setProductsReducer } from '../actions'
import { cuttingLongNameText } from '../utils'
import NavBarMobile from './navBarMobile'
var MediaQuery = require('react-responsive');
class NavHeader extends Component {

  state = {
    islogin: localStorage.getItem('user') == null ? false : true,
    searchinput: '',
    count: 1,
    user: JSON.parse(localStorage.getItem('user')),
  }

  componentWillMount() {
    if (this.props.id != undefined) {
      // console.log('fetchproducts')
      this.props.setLoadingSearchPage(true)
      this.props.changeSearchLabel(this.props.id)
      this.setState({ searchinput: this.props.id })
      this.props.fetchProducts(this.props.id)
    }
    if(localStorage.getItem('user')!=null){
      let user_info = JSON.parse(localStorage.getItem('user'))
      // window.Intercom('shutdown')
      // window.Intercom('boot', {
      //   app_id: 'j77n0bkz',
      //   user_id: user_info.phone_number,
      //   name: user_info.name+' '+user_info.lastname,
      // });
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log('np', nextProps)
    if (nextProps.searchinput != this.state.searchinput && nextProps.products == this.props.products) {
      // console.log('click category')
      this.setState({ searchinput: nextProps.searchinput })
      this.props.setLoadingSearchPage(true)
      this.props.fetchProducts(nextProps.searchinput)
      this.props.changeSearchLabel(nextProps.searchinput)
    }
    if (this.props.id != nextProps.id && this.props.searchinput == nextProps.searchinput && nextProps.id) {
      // console.log('click back forward')
      this.setState({ searchinput: nextProps.id })
      this.props.setLoadingSearchPage(true)
      this.props.fetchProducts(nextProps.id)
      this.props.changeSearchLabel(nextProps.id)
    }
  }

  componentDidMount() {
    let id
    this.props.id == undefined ? id = '' : id = this.props.id
    let strLength = id.length
    //this.searchField.focus()
    this.searchField.setSelectionRange(strLength, strLength)
    // window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  onLoginClicked() {
    this.props.history.push('/login')
  }

  onLogOut() {
    // window.Intercom('shutdown')
    // window.Intercom('boot', {
    //   app_id: 'j77n0bkz',
    // });
    localStorage.removeItem('user')
    this.props.history.push('/login')
  }

  startTimer() {
    this.setState({ count: 1 })
    clearInterval(this.timer)
    this.timer = setInterval(this.tick.bind(this), 1000)
  }

  tick() {
    this.setState({ count: (this.state.count - 1) })
    this.state.count == 0 ? this.timeout() : ''
  }

  timeout() {
    clearInterval(this.timer)
    this.setState({ count: 1 })
    this.props.fetchSearchInput(this.state.searchinput)
    if (this.state.searchinput) {
      this.props.history.push('/search/' + this.state.searchinput)
      this.props.fetchProducts(this.state.searchinput)
    } else {
      this.props.history.push('/')
    }
  }

  handleChange(e) {
    this.props.setLoadingSearchPage(true)
    this.setState({ searchinput: e })
    this.props.changeSearchLabel(e)
    this.props.setProductsReducer()
    this.startTimer()
  }

  onClear() {
    // this.props.fetchSearchInput('')
    this.props.fetchProducts()
    this.props.history.push('/')
  }

  rendermobilecart() {
    return (
      <span className="glyphicon glyphicon-shopping-cart mobile-cart" style={{ color: 'white', fontSize: 20 }}><span className="badge-cart"></span></span>
    )
  }

  renderUser() {
    if (this.state.islogin) {
      return (
        <div style={{ display: 'inline-block' }}>
          <NavDropdown
            noCaret={true}
            className="hidden-lg hidden-sm hidden-md"
            eventKey={1}
            title={<div style={{ color: 'white' }}><span className="glyphicon glyphicon-user mobile-cart" style={{ color: 'white', fontSize: 20, cursor: 'pointer' }}></span><div className="navheader-specialtext" style={{ fontSize: '14px !important', color: 'white !important', display: 'inline' }}> คุณ {cuttingLongNameText(this.state.user.name)}</div></div>}
            id="user-dropdown">
            <MenuItem style={{ marginTop: 5 }} eventKey={1.1} onClick={() => this.props.history.push('/user_info')}>โปรไฟล์ของฉัน</MenuItem>
            <MenuItem eventKey={1.2} onClick={() => this.props.history.push('/orderhistory')} >ออเดอร์ของฉัน</MenuItem>
            <MenuItem divider />
            <MenuItem eventKey={1.3} onClick={() => this.onLogOut()} >ออกจากระบบ</MenuItem>
          </NavDropdown>
          <NavDropdown
            noCaret={true}
            style={{ padding: 'unset' }}
            className="hidden-xs"
            eventKey={1}
            title={<div style={{ color: 'white' }}><span className="glyphicon glyphicon-user mobile-cart" style={{ color: 'white', fontSize: 20, cursor: 'pointer' }}></span><div className="navheader-specialtext" style={{ fontSize: '14px !important', color: 'white !important', display: 'inline' }}> คุณ {cuttingLongNameText(this.state.user.name)}</div></div>}
            id="user-dropdown">
            <MenuItem style={{ marginTop: 5 }} eventKey={1.1} onClick={() => this.props.history.push('/user_info')}>โปรไฟล์ของฉัน</MenuItem>
            <MenuItem eventKey={1.2} onClick={() => this.props.history.push('/orderhistory')} >ออเดอร์ของฉัน</MenuItem>
            <MenuItem divider />
            <MenuItem eventKey={1.3} onClick={() => this.onLogOut()} >ออกจากระบบ</MenuItem>
          </NavDropdown>
        </div>
      )
    } else {
      return (
        <div style={{ display: 'inline-block' }}>
          <div className="hidden-lg hidden-sm hidden-md" style={{ fontSize: 15 + 'px !important', color: 'white' }} onClick={() => this.onLoginClicked()}><span className="glyphicon glyphicon-user mobile-cart" style={{ color: 'white', fontSize: 20, cursor: 'pointer' }}></span><div className="navheader-specialtext" style={{ fontSize: '14px !important', color: 'white !important', display: 'inline' }}>เข้าสู่ระบบ</div></div>
          <div className="hidden-xs" style={{ fontSize: 14 + 'px !important', color: 'white' }} onClick={() => this.onLoginClicked()}><span className="glyphicon glyphicon-user mobile-cart" style={{ color: 'white', fontSize: 20, cursor: 'pointer' }}></span>&nbsp;เข้าสู่ระบบ</div>
        </div>
      )
    }
  }

  renderCart() {
    if (window.location.pathname == '/payment' || window.location.pathname == '/confirm_address' || window.location.pathname == '/order_review') {
      return (
        <NavbarCart
          disabled={true}
          history={this.props.history}
        />
      )
    } else {
      return (
        <NavbarCart
          disabled={false}
          history={this.props.history}
        />
      )
    }
  }

  render() {
    return (
      <div>
        <Navbar className="navbar navbar-default navbar-fixed-top hidden-xs">
          <div className="row">
            <div className="col-xs-2 col-sm-2 col-md-2 header-logo" style={{ paddingTop: 4 }}>
              {<div className="navbar-brand" >
                <a href="/">
                  <img src="../../static/images/logo_white_v2.png" />
                </a>
              </div>}
            </div>
            <div className="col-xs-10 col-sm-5 col-md-6" style={{ padding: 0, paddingLeft: 0 }}>
              <Navbar.Form style={{ textAlign: 'center' }}>
                <FormGroup id="formsearch">
                  <input id='search-field' ref={(input) => { this.searchField = input; }} className="form-control search-field" value={this.state.searchinput} onChange={e => { this.handleChange(e.target.value) }} style={{ borderRadius: '0px 0px 0px 0px', height: '40px' }} type="text" placeholder="ค้นหาสินค้า" />
                  <button className="btn" id="btnclearsearch" onClick={() => this.onClear()} style={{ borderRadius: '0px 0px 0px 0px', backgroundColor: '#f57224', color: '#ffffff', borderColor: '#f57224', height: '40px' }}><div>  {this.state.searchinput ? <span className="fa fa-times-circle" aria-hidden="true"></span> : <span className="fa fa-search" aria-hidden="true"></span>} </div></button>
                  {/*{' '}*/}
                </FormGroup>
              </Navbar.Form>
            </div>
            <div className="col-xs-12 col-sm-5 col-md-4" style={{ listStyle: 'none !important', paddingLeft: 0, paddingRight: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingLeft: 5, paddingBottom: 4 }}>
                {this.renderUser()}
                <div style={{ padding: 5, paddingBottom: 10 }} />
                {this.renderCart()}
              </div>
            </div>
          </div>
        </Navbar>
        <div className='hidden-sm hidden-md hidden-lg'>
          <NavBarMobile history={this.props.history} id={this.props.id} />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    searchinput: state.searchinput,
    products: state.products,
  };
}

export default connect(mapStateToProps, { fetchSearchInput, fetchProducts, changeSearchLabel, setLoadingSearchPage, setProductsReducer })(NavHeader)


// WEBPACK FOOTER //
// ./src/components/navheader.js